import { format } from 'date-fns/format';
import React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiService } from '../../../client/common/apiCallService';
import {
    getCurrencySymbol,
    getExChangeAmount,
    getTransectionDetails,
    toFixedTrunc,
} from '../../../client/Juno/helpers';
import { Popover } from '@mui/material';
import StatementDialogComponent from './StatementDialogComponent';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { generateExcel } from '../../../helpers/utils';
import { cryptoCurrencyList, fiatCurrencyList } from '../../helpers/constant';
import JunoButton from '../common/JunoButton';

function StatementMobileComponent({
    tableData = [],
    activeCurrencyPage,
    handleSeeAll,
    isDashboardPage,
}) {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const api_url = useSelector(state => state.config.api_url);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedStatementRow, setSelectedStatementRow] = useState({});

    const handleClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const onDownload = async (row, downloadType = 'pdf') => {
        apiService(
            (window.location.hostname === 'localhost' ? api_url : '') +
                '/restapi/generate-statement-pdf',
            {
                statementId: row._id,
                fromDate: row.timePeriod.fromDate || row.timePeriod.formDate,
                endDate: row.timePeriod.endDate,
                clientId: row.clientId,
                type: row.type,
                currency: row.currency,
                activeCurrencyPage,
                downloadType,
            },
            async data => {
                if (data) {
                    if (downloadType === 'pdf') {
                        const pdfData = data;
                        const newTab = window.open();
                        newTab?.document?.write(pdfData);
                    } else {
                        await generateExcel({ ...data, activeCurrencyPage });
                    }
                }
            },
            err => {
                console.log(err);
            },
        );
    };
    function openStatementModal(data) {
        setOpenModal(true);
        setSelectedStatementRow(data);
    }
    const statementPage = location.pathname.includes('/client/statements');
    function openStatementModal(row) {
        const balances = activeCurrencyPage === 'crypto' ? cryptoCurrencyList : fiatCurrencyList;
        const matchedCurrency = balances?.find(
            currency => currency.currencyShortName === row.currencyShortName,
        );

        setOpenModal(true);
        setSelectedStatementRow({ ...row, matchedCurrency });
    }

    return (
        <>
            <div>
                {tableData.map((row, idx) => {
                    const balances = activeCurrencyPage === 'crypto' ? cryptoCurrencyList : fiatCurrencyList;
                    const matchedCurrency = balances?.find(
                        currency => currency.currencyShortName === row.currencyShortName,
                    );
                    return (
                        <div
                            key={idx}
                            className={`flex justify-between items-center py-3 !border-secondary
                          border-b
                          ${isDashboardPage ? 'md:border-b-0' : ''}
                        `}>
                            <div className="px-4 flex items-center gap-3 w-full justify-between">
                                <div
                                    className="flex items-center gap-3"
                                    onClick={() => openStatementModal(row)}>
                                    <div className="relative !p-2 bg-[#E5E7EB] dark:bg-[#374151] rounded-full flex items-center justify-center">
                                        <DescriptionOutlinedIcon className=" w-6 h-6 dark:!text-white" />
                                        {matchedCurrency?.currencyIcon && (
                                            <img
                                                src={`${imageBaseUrl}${matchedCurrency?.currencyIcon}`}
                                                alt={matchedCurrency.currencyShortName}
                                                className="w-5 h-5 p-[1px] bg-white dark:!bg-[#26272B] rounded-full absolute top-[-0.30rem] right-[-0.4rem]"
                                            />
                                        )}
                                    </div>
                                    <div className="flex flex-col">
                                        <p className="text-balanceCard-manage  font-inter font-medium text-[14px] leading-[20px] tracking-normal">
                                            {format(new Date(row.createdAt), 'dd.MM.yy HH:mm')}
                                        </p>
                                        <p className="text-[#18181B] font-medium text-[14px] leading-[20px] tracking-normal dark:!text-white">
                                            {getCurrencySymbol(row.currency)}{' '}
                                            {toFixedTrunc(row.openingBalance)}
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    <div onClick={e => handleClick(e, row)} className="">
                                        <img
                                            src={`${imageBaseUrl}/downloadFileIcon.svg`}
                                            className="w-6 h-6 !text-white dark:filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
                                        />
                                    </div>
                                    <Popover
                                        className=""
                                        id={id}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        sx={{
                                            '& .MuiPaper-root': {
                                                backgroundColor: 'transparent', // Remove default background
                                                boxShadow: 'none', // Remove default shadow
                                            },
                                        }}>
                                        <div className="!bg-card-bg">
                                            <div className="p-2 rounded-lg">
                                                <button
                                                    className="flex justify-between items-center gap-3 px-3 text-sm font-medium !text-text"
                                                    onClick={() => onDownload(selectedRow)}>
                                                    <img
                                                        src={`${imageBaseUrl}/adminUi/pdf.svg`}
                                                        className="w-6 h-6"
                                                        alt="download"
                                                    />
                                                    PDF file
                                                </button>
                                                <button
                                                    className="flex justify-between items-center gap-3 px-3 text-sm font-medium !text-text mt-2"
                                                    onClick={() =>
                                                        onDownload(selectedRow, 'excel')
                                                    }>
                                                    <img
                                                        src={`${imageBaseUrl}/adminUi/excel.svg`}
                                                        className="w-6 h-6"
                                                        alt="download"
                                                    />
                                                    Excel file
                                                </button>
                                            </div>
                                        </div>
                                    </Popover>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {!statementPage && (
                <div className="pt-0 w-full !p-5">
                    <div className="h-10 py-3 bg-zinc-200 rounded flex justify-center items-center">
                        <JunoButton type='secondary' onClick={handleSeeAll}>SEE ALL</JunoButton>
                    </div>
                </div>
            )}
            {openModal && (
                <StatementDialogComponent
                    open={openModal}
                    onModalClose={() => setOpenModal(false)}
                    statementsData={selectedStatementRow}
                    onDownload={onDownload}
                />
            )}
        </>
    );
}

export default StatementMobileComponent;
